(function(){
  "use strict";

  angular
    .module("modules.device", [])
  ;

})();